export const MESSAGE_TYPE = {
  param: "param",
  query: "query",
};

export function disabledTabMoveButton(buttonClassName) {
  const buttonEleArr = document.getElementsByTagName("button");
  buttonEleArr.forEach((buttonEle) => {
    if (buttonClassName !== undefined && !buttonClassName.includes(buttonEle.className)) {
      buttonEle.setAttribute("tabindex", -1);
    }

    if(buttonClassName === undefined) {
      buttonEle.setAttribute("tabindex", -1);
    }
  });
}

export function disabledTabMoveInput(inputClassName) {
  const inputEleArr = document.getElementsByTagName("input");
  inputEleArr.forEach((inputEle) => {
    if (inputClassName !== undefined && !inputClassName.includes(inputEle.className)) {
      inputEle.setAttribute("tabindex", -1);
    }

    if(inputClassName === undefined) {
      inputEle.setAttribute("tabindex", -1);
    }
  });
}

export function fallbackTabMove() {
  const buttonEleArr = document.getElementsByTagName("button");
  const inputEleArr = document.getElementsByTagName("input");
  buttonEleArr.forEach((buttonEle) => {
    buttonEle.removeAttribute("tabindex");
  });
  inputEleArr.forEach((inputEle) => {
    inputEle.removeAttribute("tabindex");
  });
}

export function cleanHTML(htmlString) {  
  return htmlString?.replace(/(<([^>]+)>)/ig, "");
}

// 캐로셀 tabIndex 삭제
export function removeLiTabIndex() {
  const carouselContainers = document.querySelectorAll('._message_temp_carousel_div');
  const carouselArray = Array.from(carouselContainers);
  const carouselLastIndex = carouselArray.length - 1;

  carouselContainers.forEach((cCon, cIndex ) => {
    if (cIndex === carouselLastIndex) {
      const carouselItems = document.querySelectorAll('.carousel-item');
      if (carouselItems) {
        carouselItems.forEach((item) => {
        item.removeAttribute('tabindex');
        item.removeAttribute('role');
        });
      }
    
      const liElements = cCon.querySelectorAll('li[tabindex="-1"]');
       liElements.forEach((li, index) => {
        li.removeAttribute('tabindex');
        li.removeAttribute('role');
        li.removeAttribute('aria-selected');
        li.setAttribute('index', index);
     });
    }
  });
}